"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitApiClient = void 0;
var amorphic_1 = require("@haventech/amorphic");
var apollo_fetch_1 = require("apollo-fetch");
var HitClientAppCtx_1 = require("./HitClientAppCtx");
var utils_1 = require("@hit/utils");
var logger_1 = require("@hit/logger");
var package_json_1 = require("../package.json");
var gqlEndpoint = '/gql';
var HitApiClient = /** @class */ (function (_super) {
    __extends(HitApiClient, _super);
    function HitApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HitApiClient.prototype.generateLogIdentifiers = function () {
        return {
            globalId: utils_1.Utils.generateUuid(),
            globalSource: 'hit-api-client'
        };
    };
    Object.defineProperty(HitApiClient.prototype, "log", {
        get: function () {
            return HitClientAppCtx_1.HitClientAppCtx.get.logger(this.constructor.name);
        },
        enumerable: false,
        configurable: true
    });
    HitApiClient.new = function (overrideUrl, logger) {
        return new this().init(overrideUrl, logger);
    };
    HitApiClient.prototype.init = function (overrideUrl, logger) {
        this.logger = logger || this.getDefaultLogger();
        var hitDataServiceUrl = overrideUrl || HitClientAppCtx_1.HitClientAppCtx.get.config.hitDataServiceUrl;
        var logContextMetadata = this.generateLogIdentifiers();
        if (!hitDataServiceUrl) {
            this.logger.error({
                module: 'HitApiClient',
                function: 'init',
                category: 'milestone',
                context: __assign({}, logContextMetadata),
                error: {
                    message: 'hitDataServiceUrl is not defined',
                    isHumanRelated: false,
                }
            }, 'Initializing');
        }
        else {
            this.logger.info({
                module: 'HitApiClient',
                function: 'init',
                category: 'milestone',
                context: __assign({}, logContextMetadata),
                data: {
                    hitDataServiceUrl: hitDataServiceUrl,
                }
            }, 'Initializing');
        }
        this.gqlUri = hitDataServiceUrl + gqlEndpoint;
        this.apolloFetch = (0, apollo_fetch_1.createApolloFetch)({ uri: this.gqlUri });
        return this;
    };
    HitApiClient.prototype.buildQuery = function (obj) {
        var _this = this;
        var _on = '_on';
        if (obj instanceof Array && obj.length > 0) {
            obj = obj[0];
        }
        var keys = Object.keys(obj);
        if (keys.length === 0) {
            return '';
        }
        var indexOfOn = keys.indexOf(_on);
        var onObj = obj[_on];
        if (indexOfOn > -1) {
            keys.splice(indexOfOn, 1);
        }
        var query = '{';
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            query = "".concat(query, " ").concat(key);
            if (obj[key] !== null && typeof obj[key] === 'object' && !(obj[key] instanceof Date)) {
                query = "".concat(query, " ").concat(this.buildQuery(obj[key]));
            }
        }
        if (onObj) {
            var keysOfOn = Object.keys(onObj);
            if (keysOfOn.length > 0) {
                query = "".concat(query, " __typename ");
            }
            keysOfOn.forEach(function (keyOfOn) {
                query = "".concat(query, " ... on ").concat(keyOfOn, " ").concat(_this.buildQuery(onObj[keyOfOn]), " ");
            });
        }
        return "".concat(query, " }");
    };
    HitApiClient.prototype.gqlFetch = function (query, variables) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.apolloFetch({ query: query, variables: variables })
                        .then(function (result) {
                        var logContextMetadata = _this.generateLogIdentifiers();
                        // GraphQL errors and extensions are optional
                        if (result.errors && result.errors.length > 0) {
                            var errorMessages = result.errors.reduce(function (messages, error) {
                                var message = error.message;
                                messages += "".concat(message, "\n");
                                _this.log.error('HitApiClient', "GQL Error: ".concat(message), result.errors, {
                                    module: 'HitApiClient',
                                    function: 'init',
                                    category: 'milestone',
                                    context: __assign({}, logContextMetadata),
                                    error: {
                                        message: message,
                                        isHumanRelated: false,
                                    }
                                });
                                return messages;
                            }, '');
                            throw new Error("GQL error was found:\n ".concat(errorMessages));
                        }
                        return result;
                    })
                        .catch(function (error) {
                        throw new Error("Cannot fetch from GQL endpoint: ".concat(error));
                    })];
            });
        });
    };
    HitApiClient.prototype.setStatus = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query uwSetStatus($request: StatusRequest) {\n           uwSetStatus(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.notifyUwStageUpdate = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query notifyUwStageUpdate($request: NotifyStageRequest) {\n            notifyUwStageUpdate(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.confirmSubmitFollowUp = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query confirmSubmitFollowUp($request: ConfirmSubmitFollowUpRequest) {\n            confirmSubmitFollowUp(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getApplicationData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query applicationData($request: ApplicationRequest) {\n            applicationData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getRareCustomerSelectedRxIndications = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query customerSelectedRxIndications($request: RxSelectionRequest) {\n            customerSelectedRxIndications(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getRareSupplements = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query rareSupplements($request: RareSupplementsRequest) {\n            rareSupplements(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getRareLongForm = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query rareLongForm($request: RareLongFormRequest) {\n            rareLongForm(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getFixIdData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query fixIdData($request: FixIdDataRequest) {\n            fixIdData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getFixMVRData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query fixMVRData($request: FixMVRDataRequest) {\n            fixMVRData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getCurrentStage = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query currentStage($request: CurrentStageRequest) {\n            currentStage(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getCustomerInfo = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query customerInfo($request: CustomerInfoRequest) {\n            customerInfo(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getPolicyDocAppsData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query policyDocAppsData($request: PolicyDocRequest) {\n            policyDocAppsData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getDocuSignTabs = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query docuSignTabs($request: DocuSignTabsRequest) {\n            docuSignTabs(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getExamVendor = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query examVendorData($request: ExamVendorRequest) {\n            examVendorData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getAgentData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query agentData($request: AgentRequest) {\n            agentData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getAppsAppointmentData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query appsAppointmentData($request: AppsAppointmentDataRequest) {\n            appsAppointmentData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getPolicyInfo = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var requestQuery;
            return __generator(this, function (_a) {
                requestQuery = "query policyInfo($request: PolicyInfoRequest) {\n             policyInfo(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(requestQuery, { request: request })];
            });
        });
    };
    HitApiClient.prototype.getDefaultLogger = function () {
        return new logger_1.Logger({
            level: HitClientAppCtx_1.HitClientAppCtx.get.config.logConfig.level || 'info',
            appVersion: package_json_1.version,
            environment: HitClientAppCtx_1.HitClientAppCtx.get.config.APP_ENV || HitClientAppCtx_1.HitClientAppCtx.get.config.NODE_ENV || 'development',
            app: package_json_1.name
        }).getSystemLogger();
    };
    HitApiClient = __decorate([
        (0, amorphic_1.supertypeClass)({ toClient: false, toServer: false })
    ], HitApiClient);
    return HitApiClient;
}(amorphic_1.Supertype));
exports.HitApiClient = HitApiClient;
//# sourceMappingURL=HitApiClient.js.map